import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ChevronRight, ExternalLink } from "lucide-react";
import { useHeaderStore } from "../../store/headerStore";
import "../../styles/help-center.css";

interface WikiTopic {
  id: string;
  title: string;
  description: string;
  linkText?: string;
  linkTo?: string;
}

const WIKI_TOPICS: WikiTopic[] = [
  {
    id: "threat-feed",
    title: "Threat Feed",
    description:
      "Threat Feed is one of the major features of Threatactix which allows the user to get the wide range of information about the latest and oldest posts posted by the threat actor about their victims and so on.",
    linkText: "Go to Intelligence Feed",
    linkTo: "/leaks",
  },
  {
    id: "threat-actor-directory",
    title: "Threat Actor Directory",
    description:
      "Threat Actor Directory of Threatactix has all the details of the threat actors and their details including victims, alias, affiliations, incidents and TTPs. It also shares the collaboration between threat actors.",
    linkText: "View Ransomware & Threat Groups",
    linkTo: "/dashboard",
  },
  {
    id: "incidents",
    title: "Incidents",
    description:
      "Threatactix Incidents keep tracks of recent incidents of cyber attacks. The details of Threat actors linked to the incidents and their corresponding victims.",
    linkText: "View Threat Timeline",
    linkTo: "/timeline",
  },
  {
    id: "domain-monitor",
    title: "Domain & Brand Monitoring",
    description:
      "Domain Monitor provides automated surveillance over corporate assets, tracking lookalike phishing domains, SSL anomalies, DNS records, and corporate employee email disclosures across dark web paste sites.",
    linkText: "Open Domain Monitor",
    linkTo: "/domain-monitor",
  },
  {
    id: "customer-check",
    title: "Customer Check",
    description:
      "Customer Check queries billions of leaked credentials, compromised accounts, and stealer logs to determine if employee or client data has been exposed in historic or recent dark web breaches.",
    linkText: "Search Customer Leaks",
    linkTo: "/customer-check",
  },
  {
    id: "takedowns",
    title: "Takedowns & Remediation",
    description:
      "Takedowns management facilitates the end-to-end takedown process for brand impersonation, fraudulent domains, and leaked proprietary source code, tracking registrar tickets and legal takedown progress.",
    linkText: "Manage Takedowns",
    linkTo: "/takedowns",
  },
  {
    id: "alerts",
    title: "Threat Alerts & Notification Rules",
    description:
      "Alert Config empowers SOC teams to set up automated surveillance rules. When threat actors discuss your company keywords, executives, or IP subnets, alerts trigger instant email or webhook deliveries.",
    linkText: "Configure Alerts",
    linkTo: "/alerts",
  },
];

export default function HelpCenterWikiPage() {
  const { setPageTitleOverride } = useHeaderStore();

  useEffect(() => {
    setPageTitleOverride("WIKI");
    return () => setPageTitleOverride(null);
  }, [setPageTitleOverride]);

  return (
    <div className="help-center-container">
      {/* Back button */}
      <Link to="/help-center" className="help-back-btn">
        <ArrowLeft size={16} />
        <span>Back</span>
      </Link>

      {/* Main Title */}
      <div className="help-page-header">
        <h1 className="help-page-title">Wiki</h1>
      </div>

      {/* Wiki Cards Stack matching Image 3 */}
      <div className="wiki-cards-list">
        {WIKI_TOPICS.map((topic) => (
          <div key={topic.id} className="wiki-topic-card">
            <h2 className="wiki-topic-title">{topic.title}</h2>
            <p className="wiki-topic-desc">{topic.description}</p>
            {topic.linkTo && topic.linkText && (
              <Link to={topic.linkTo} className="wiki-topic-action-link">
                <span>{topic.linkText}</span>
                <ChevronRight size={13} />
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
